export default __webpack_public_path__ + "static/swarm-aca437ff3639ecf6348aa4ccfde2db67.png";